module.exports = __webpack_public_path__ + "img/8.92d16fd8.jpg";